import type { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { AbstractControl } from '@angular/forms';

export const formSingalValue = <T extends AbstractControl>(control: T): Signal<T['value']> =>
  toSignal(control.valueChanges, {
    requireSync: false,
    initialValue: control.value,
  });
